import React from 'react';
import 'prop-types';
import { jsxs, jsx } from 'react/jsx-runtime';
const icons = {
  'credit_&_term': (height, width, primaryColor, secondaryColor) => /*#__PURE__*/jsxs("svg", {
    width: width,
    height: height,
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    children: [/*#__PURE__*/jsxs("g", {
      children: [/*#__PURE__*/jsx("path", {
        d: "M25.5,9c-1.65-.49-3.19-1-5-1s-4.39,.53-6,1l2.94,7.23,.24-1.55v-.02s0-.02,0-.02c.19-1.08,1.15-1.83,2.32-1.83h0c1.17,0,2.12,.75,2.31,1.84v.02s0,.02,0,.02l.26,1.64,.92-.32,2-7Z",
        fill: secondaryColor
      }), /*#__PURE__*/jsx("path", {
        d: "M26.48,23.15c.41,.78,.69,1.64,.79,2.56h10.93c-.15-3.2-1.13-6.19-2.73-8.76l-8.99,6.2Z",
        fill: "none"
      }), /*#__PURE__*/jsx("path", {
        d: "M1.8,25.71H12.73c.12-1.03,.45-1.99,.95-2.85l-8.98-6.19c-1.7,2.63-2.75,5.72-2.9,9.04Z",
        fill: "none"
      }), /*#__PURE__*/jsx("path", {
        d: "M20,6.65C9.02,6.65,.09,15.58,.09,26.55c0,.47,.38,.85,.85,.85H13.53c.47,0,.85-.38,.85-.85,0-1.79,.84-3.38,2.14-4.41l.34-2.19c-.81,.39-1.54,.92-2.15,1.56L5.69,15.29c1.98-2.52,4.62-4.5,7.65-5.69l3.55,10.17,.56-3.54h0l-2.5-7.18c1.61-.47,3.31-.72,5.07-.72s3.56,.27,5.21,.76l-2.64,7.15v.08s.54,3.34,.54,3.34l3.7-10.01c3.07,1.24,5.73,3.3,7.71,5.9l-8.99,6.2c-.66-.75-1.46-1.37-2.38-1.81l.34,2.19c1.3,1.03,2.14,2.63,2.14,4.41,0,.47,.38,.85,.85,.85h12.59c.47,0,.85-.38,.85-.85,0-10.98-8.93-19.91-19.91-19.91Zm-6.32,16.22c-.5,.85-.84,1.82-.95,2.85H1.8c.15-3.32,1.2-6.41,2.9-9.04l8.98,6.19Zm13.59,2.85c-.11-.91-.38-1.78-.79-2.56l8.99-6.2c1.6,2.57,2.58,5.56,2.73,8.76h-10.93Z",
        fill: primaryColor
      })]
    }), /*#__PURE__*/jsx("path", {
      d: "M22.07,23.99l-1.42-9.04c-.05-.29-.35-.44-.65-.44-.3,0-.6,.15-.65,.44l-1.42,9.04c-1.68,.78-2.84,2.48-2.84,4.45,0,2.71,2.2,4.91,4.91,4.91s4.91-2.2,4.91-4.91c0-1.97-1.16-3.67-2.84-4.45Z",
      fill: secondaryColor
    })]
  }),
  monthly_payment: (height, width, primaryColor, secondaryColor) => /*#__PURE__*/jsxs("svg", {
    width: width,
    height: height,
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    children: [/*#__PURE__*/jsxs("g", {
      children: [/*#__PURE__*/jsxs("g", {
        children: [/*#__PURE__*/jsx("rect", {
          x: "9.23",
          y: "16.81",
          width: "4.55",
          height: "4.55",
          rx: ".91",
          ry: ".91",
          fill: primaryColor
        }), /*#__PURE__*/jsx("rect", {
          x: "16.14",
          y: "16.81",
          width: "4.55",
          height: "4.55",
          rx: ".91",
          ry: ".91",
          fill: primaryColor
        }), /*#__PURE__*/jsx("rect", {
          x: "23.05",
          y: "16.81",
          width: "4.55",
          height: "4.55",
          rx: ".91",
          ry: ".91",
          fill: primaryColor
        })]
      }), /*#__PURE__*/jsxs("g", {
        children: [/*#__PURE__*/jsx("rect", {
          x: "9.23",
          y: "23.72",
          width: "4.55",
          height: "4.55",
          rx: ".91",
          ry: ".91",
          fill: primaryColor
        }), /*#__PURE__*/jsx("rect", {
          x: "16.14",
          y: "23.72",
          width: "4.55",
          height: "4.55",
          rx: ".91",
          ry: ".91",
          fill: primaryColor
        }), /*#__PURE__*/jsx("rect", {
          x: "23.05",
          y: "23.72",
          width: "4.55",
          height: "4.55",
          rx: ".91",
          ry: ".91",
          fill: primaryColor
        })]
      }), /*#__PURE__*/jsxs("g", {
        children: [/*#__PURE__*/jsx("path", {
          d: "M19.77,30.63h-6.73s-.06,0-.09,0c-.03,0-.06,0-.09,0h-2.73c-.5,0-.91,.41-.91,.91v2.73c0,.5,.41,.91,.91,.91h2.73s.06,0,.09,0c.03,0,.06,0,.09,0h6.73c.5,0,.91-.41,.91-.91v-2.73c0-.5-.41-.91-.91-.91Z",
          fill: secondaryColor
        }), /*#__PURE__*/jsx("rect", {
          x: "23.05",
          y: "30.63",
          width: "4.55",
          height: "4.55",
          rx: ".91",
          ry: ".91",
          fill: primaryColor
        })]
      })]
    }), /*#__PURE__*/jsxs("g", {
      children: [/*#__PURE__*/jsx("path", {
        d: "M30.5,36.83c0,.52-.42,.94-.94,.94H7.25c-.52,0-.94-.42-.94-.94V6.52c0-.52,.42-.94,.94-.94h14.11c.16-.6,.38-1.17,.66-1.71H7.25c-1.46,0-2.64,1.19-2.64,2.64v30.31c0,1.46,1.19,2.64,2.64,2.64H29.57c1.46,0,2.64-1.19,2.64-2.64V16.82c-.55,.13-1.12,.21-1.71,.23v19.78Z",
        fill: primaryColor
      }), /*#__PURE__*/jsx("path", {
        d: "M8.65,9.14v3.87c0,1.01,.82,1.83,1.83,1.83h13.73c-.58-.5-1.1-1.08-1.54-1.71H10.47c-.06,0-.12-.05-.12-.12v-3.87c0-.06,.05-.12,.12-.12h10.63c-.04-.35-.06-.7-.06-1.06,0-.22,.01-.43,.03-.65H10.47c-1.01,0-1.83,.82-1.83,1.83Z",
        fill: primaryColor
      })]
    }), /*#__PURE__*/jsx("path", {
      d: "M30.14,.53c-4.11,0-7.43,3.33-7.43,7.43s3.33,7.43,7.43,7.43,7.43-3.33,7.43-7.43S34.24,.53,30.14,.53Zm1.2,11.52v1.18h-2.11v-1.1c-.91-.07-1.72-.3-2.52-.89l1.2-1.79c.51,.41,1.34,.84,2.14,.84,.38,0,.92-.07,.92-.47s-.31-.49-.69-.6l-1.42-.39c-1.09-.31-1.87-1.11-1.87-2.32s.84-2.36,2.25-2.72v-1.09h2.11v1.03c.8,.11,1.35,.35,2.01,.74l-1.33,1.71c-.42-.36-1.17-.57-1.66-.57-.51,0-.9,.11-.9,.49s.43,.43,.99,.6l1.17,.32c1.32,.38,1.91,1.21,1.91,2.31,0,1.59-1.03,2.42-2.2,2.72Z",
      fill: secondaryColor
    })]
  }),
  down_payment: (height, width, primaryColor, secondaryColor) => /*#__PURE__*/jsxs("svg", {
    width: width,
    height: height,
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    children: [/*#__PURE__*/jsx("path", {
      d: "M32.15,6.91H1.31C.61,6.91,.04,7.48,.04,8.18V25.29c0,.7,.57,1.27,1.27,1.27h30.84c.7,0,1.27-.57,1.27-1.27V8.18c0-.7-.57-1.27-1.27-1.27Zm-.43,4.89c-1.46-.37-2.57-1.64-2.69-3.19h2.69v3.19Zm-4.3,13.06H6.76c-.49-2.35-2.54-4.13-5.02-4.21v-7.04c2.75-.09,4.97-2.27,5.12-5H27.32c.13,2.49,1.99,4.52,4.4,4.93v7.18c-2.14,.36-3.85,2.02-4.3,4.14ZM5.15,8.61c-.14,1.79-1.6,3.21-3.41,3.3v-3.3h3.41ZM1.74,22.37c1.53,.07,2.81,1.1,3.26,2.5H1.74v-2.5Zm27.44,2.5c.37-1.17,1.33-2.09,2.54-2.39v2.39h-2.54Z",
      fill: primaryColor
    }), /*#__PURE__*/jsx("path", {
      d: "M15.62,22.12c-1.15-.09-2.18-.38-3.19-1.12l1.51-2.27c.65,.51,1.69,1.06,2.71,1.06,.48,0,1.17-.09,1.17-.59s-.39-.62-.88-.76l-1.8-.5c-1.38-.39-2.36-1.41-2.36-2.94s1.06-2.98,2.84-3.43v-1.38s2.66,0,2.66,0v1.3c1.01,.14,1.71,.44,2.54,.94l-1.68,2.16c-.53-.45-1.48-.73-2.1-.73-.65,0-1.13,.14-1.13,.62s.54,.54,1.26,.76l1.48,.41c1.66,.48,2.42,1.53,2.42,2.92,0,2.01-1.3,3.06-2.78,3.43v1.5s-2.66,0-2.66,0v-1.39Z",
      fill: secondaryColor
    }), /*#__PURE__*/jsx("path", {
      d: "M39.96,15.15c0-.47-.38-.85-.85-.85s-.84,.37-.85,.84h-.01V31.39H7.68c-.47,0-.85,.38-.85,.85s.38,.85,.85,.85h31c.7,0,1.27-.57,1.27-1.27v-12.41s.01-.07,.01-.1v-4.16Z",
      fill: primaryColor
    }), /*#__PURE__*/jsx("path", {
      d: "M36.69,11.89c0-.47-.38-.85-.85-.85s-.84,.37-.85,.84h-.01V28.13H4.41c-.47,0-.85,.38-.85,.85s.38,.85,.85,.85h31c.7,0,1.27-.57,1.27-1.27v-12.41s.01-.07,.01-.1v-4.16Z",
      fill: primaryColor
    })]
  }),
  mileage: (height, width, primaryColor, secondaryColor) => /*#__PURE__*/jsxs("svg", {
    width: height,
    height: width,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/jsxs("g", {
      clipPath: "url(#clip0_1338_1480)",
      children: [/*#__PURE__*/jsx("path", {
        d: "M22.4401 16.465C22.469 16.465 22.4975 16.4593 22.5242 16.4483C22.5509 16.4372 22.5752 16.421 22.5956 16.4006C22.616 16.3801 22.6323 16.3559 22.6433 16.3292C22.6544 16.3025 22.66 16.2739 22.66 16.245V7.345C22.66 7.31611 22.6544 7.28749 22.6433 7.2608C22.6323 7.23411 22.616 7.20987 22.5956 7.18944C22.5752 7.16901 22.5509 7.15279 22.5242 7.14174C22.4975 7.13068 22.469 7.125 22.4401 7.125H22.01V8.33501C21.9967 8.56543 21.9363 8.79068 21.8325 8.99686C21.7288 9.20304 21.5838 9.38577 21.4067 9.53381C21.2297 9.68185 21.0242 9.79206 20.8029 9.85762C20.5815 9.92318 20.3491 9.9427 20.12 9.91499C19.21 9.91499 18.2001 9.505 18.2001 8.345V7.125H17.58V16.465H22.4401ZM20.34 11.745H20.89V15.995H21.79V16.465H18.71V15.995H19.71V12.835L18.77 12.895L18.6901 12.065L20.34 11.745Z",
        fill: secondaryColor
      }), /*#__PURE__*/jsx("path", {
        d: "M20.1401 8.925C20.2226 8.92932 20.3052 8.91623 20.3824 8.8866C20.4595 8.85697 20.5296 8.81145 20.5881 8.75299C20.6465 8.69453 20.692 8.62445 20.7216 8.54727C20.7512 8.47009 20.7644 8.38755 20.7601 8.30499V7.125H19.48V8.325C19.478 8.40957 19.4942 8.49359 19.5275 8.57137C19.5608 8.64914 19.6104 8.71885 19.673 8.77576C19.7356 8.83266 19.8097 8.87543 19.8903 8.90118C19.9709 8.92694 20.0561 8.93506 20.1401 8.925V8.925Z",
        fill: secondaryColor
      }), /*#__PURE__*/jsx("path", {
        d: "M22.4401 6.125H1.22998C0.905489 6.12499 0.594154 6.25321 0.36377 6.48172C0.133385 6.71023 0.00263814 7.02052 0 7.345V16.245C0.00263814 16.5695 0.133385 16.8798 0.36377 17.1083C0.594154 17.3368 0.905489 17.465 1.22998 17.465H22.4401C22.7636 17.465 23.0739 17.3365 23.3027 17.1077C23.5315 16.8789 23.66 16.5686 23.66 16.245V7.345C23.66 7.02144 23.5315 6.71112 23.3027 6.48233C23.0739 6.25354 22.7636 6.125 22.4401 6.125V6.125ZM1 16.245V7.345C0.999969 7.31525 1.00602 7.2858 1.0177 7.25844C1.02938 7.23107 1.04649 7.20636 1.06799 7.18579C1.08949 7.16523 1.11484 7.14923 1.1427 7.13878C1.17056 7.12833 1.20026 7.12365 1.22998 7.125H22.4401C22.469 7.125 22.4975 7.13068 22.5242 7.14174C22.5509 7.15279 22.5752 7.16901 22.5956 7.18944C22.616 7.20987 22.6323 7.23411 22.6433 7.2608C22.6544 7.28749 22.66 7.31611 22.66 7.345V16.245C22.66 16.2739 22.6544 16.3025 22.6433 16.3292C22.6323 16.3559 22.616 16.3801 22.5956 16.4006C22.5752 16.421 22.5509 16.4372 22.5242 16.4483C22.4975 16.4593 22.469 16.465 22.4401 16.465H1.22998C1.20026 16.4663 1.17056 16.4617 1.1427 16.4512C1.11484 16.4408 1.08949 16.4248 1.06799 16.4042C1.04649 16.3836 1.02938 16.3589 1.0177 16.3316C1.00602 16.3042 0.999969 16.2747 1 16.245Z",
        fill: primaryColor
      }), /*#__PURE__*/jsx("path", {
        d: "M2.19006 12.8448V10.7648C2.19006 9.6448 3.18998 9.1748 4.09998 9.1748C5.00998 9.1748 6 9.63481 6 10.7848V12.7848C5.98796 13.0161 5.92849 13.2424 5.82532 13.4498C5.72214 13.6572 5.5775 13.8411 5.40027 13.9902C5.22304 14.1393 5.017 14.2504 4.79504 14.3165C4.57309 14.3827 4.33992 14.4025 4.10999 14.3748C3.19999 14.4148 2.19006 14.0048 2.19006 12.8448ZM4.72998 12.8448V10.7648C4.73187 10.6851 4.71673 10.6059 4.68555 10.5325C4.65436 10.4591 4.60789 10.3933 4.54919 10.3393C4.4905 10.2853 4.42095 10.2445 4.34521 10.2196C4.26948 10.1947 4.18926 10.1862 4.10999 10.1948C4.0273 10.1847 3.94351 10.1926 3.86414 10.2178C3.78476 10.2431 3.7117 10.2851 3.65002 10.3411C3.58835 10.3971 3.5395 10.4657 3.50671 10.5422C3.47393 10.6188 3.45791 10.7015 3.45996 10.7848V12.8548C3.47941 13.0095 3.55471 13.1518 3.67163 13.2549C3.78855 13.358 3.93906 13.415 4.09497 13.415C4.25088 13.415 4.40151 13.358 4.51843 13.2549C4.63535 13.1518 4.71053 13.0095 4.72998 12.8548V12.8448Z",
        fill: primaryColor
      }), /*#__PURE__*/jsx("path", {
        d: "M7.38 12.8448V10.7648C7.38 9.6448 8.38004 9.1748 9.29004 9.1748C10.2 9.1748 11.2001 9.63481 11.2001 10.7848V12.7848C11.1867 13.0165 11.126 13.2431 11.0217 13.4505C10.9175 13.6579 10.7719 13.8417 10.5939 13.9907C10.4159 14.1396 10.2092 14.2506 9.98669 14.3166C9.76418 14.3827 9.53051 14.4025 9.30005 14.3748C8.39005 14.4148 7.38 14.0048 7.38 12.8448ZM9.92004 12.8448V10.7648C9.92193 10.6851 9.9068 10.6059 9.87561 10.5325C9.84442 10.4591 9.79783 10.3933 9.73914 10.3393C9.68044 10.2853 9.61089 10.2445 9.53516 10.2196C9.45942 10.1947 9.37932 10.1862 9.30005 10.1948C9.21768 10.1864 9.13444 10.1954 9.05579 10.2213C8.97713 10.2471 8.90481 10.2892 8.84351 10.3449C8.7822 10.4005 8.73328 10.4685 8.69995 10.5443C8.66662 10.62 8.6496 10.702 8.65002 10.7848V12.8548C8.64817 12.9384 8.66408 13.0215 8.69678 13.0985C8.72948 13.1755 8.77825 13.2447 8.83972 13.3014C8.90119 13.3581 8.97398 13.4012 9.05334 13.4276C9.13271 13.4541 9.21683 13.4633 9.30005 13.4548C9.38969 13.4627 9.47988 13.4497 9.5636 13.4167C9.64732 13.3837 9.7222 13.3316 9.78235 13.2647C9.8425 13.1978 9.88627 13.1178 9.91016 13.031C9.93404 12.9442 9.93746 12.8531 9.92004 12.7648V12.8448Z",
        fill: primaryColor
      }), /*#__PURE__*/jsx("path", {
        d: "M12.58 12.8448V10.7648C12.58 9.6448 13.58 9.1748 14.49 9.1748C15.4 9.1748 16.39 9.63481 16.39 10.7848V12.7848C16.3767 13.0165 16.3159 13.2431 16.2117 13.4505C16.1074 13.6579 15.9618 13.8417 15.7838 13.9907C15.6058 14.1396 15.3992 14.2506 15.1766 14.3166C14.9541 14.3827 14.7205 14.4025 14.49 14.3748C13.59 14.4148 12.58 14.0048 12.58 12.8448ZM15.12 12.8448V10.7648C15.1221 10.6841 15.1067 10.604 15.075 10.5298C15.0432 10.4557 14.9957 10.3893 14.9359 10.3351C14.8761 10.281 14.8052 10.2404 14.7283 10.2162C14.6513 10.192 14.57 10.1847 14.49 10.1948C14.4081 10.1863 14.3253 10.1953 14.2472 10.2212C14.169 10.2471 14.0973 10.2894 14.0367 10.3452C13.9762 10.401 13.9282 10.4691 13.896 10.5449C13.8638 10.6207 13.8481 10.7025 13.85 10.7848V12.8548C13.8467 12.938 13.8613 13.0208 13.8928 13.0979C13.9244 13.1749 13.9721 13.2442 14.0328 13.3011C14.0935 13.358 14.1659 13.4012 14.2448 13.4277C14.3236 13.4542 14.4072 13.4635 14.49 13.4548C14.5815 13.4656 14.6743 13.4548 14.7609 13.4234C14.8475 13.3919 14.9256 13.3405 14.9888 13.2734C15.052 13.2064 15.0985 13.1254 15.1248 13.0371C15.151 12.9488 15.1563 12.8555 15.14 12.7648L15.12 12.8448Z",
        fill: primaryColor
      })]
    }), /*#__PURE__*/jsx("defs", {
      children: /*#__PURE__*/jsx("clipPath", {
        id: "clip0_1338_1480",
        children: /*#__PURE__*/jsx("rect", {
          width: "24",
          height: "24",
          fill: "white",
          transform: "translate(0 0.125)"
        })
      })
    })]
  })
};
const DynamicIcon = /*#__PURE__*/React.memo(_ref => {
  let {
    logo = 'credit_&_term',
    height = 40,
    width = 40
  } = _ref;
  const primaryColor = 'var(--comp-color-fill-spot-icon-primary, #6d7780)';
  const secondaryColor = 'var(--comp-color-fill-spot-icon-secondary, #ff864d)';
  const renderIcons = icons[logo];
  return renderIcons ? renderIcons(height, width, primaryColor, secondaryColor) : null;
});
export { DynamicIcon as default };
